export const clean = (s) => (s || "").replace(/-/g, "");
export const servicePath = (slug, cap) => `/coreservices/${clean(slug)}${cap ? `/${clean(cap)}` : ""}`;
